var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.789 304.46C462.299 345.36 433.229 390.18 390.439 404.78C325.799 426.83 320.019 479.85 202.699 479.49C184.409 479.44 167.429 477.52 151.759 474.02C143.339 472.14 135.289 469.79 127.639 467.02C58.1394 441.95 20.0894 382.33 14.6594 318.62C7.49936 234.83 64.5294 192.55 101.689 167.65C138.849 142.75 181.219 50.2 296.559 49.65C314.139 49.57 331.759 51.3 348.919 55.24C388.079 64.23 428.379 85.91 452.579 118.94C454.399 121.42 456.139 123.97 457.809 126.56C490.459 177.36 494.189 248.7 475.789 304.46Z",
    fill: "#027AAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M475.789 304.46C462.299 345.36 433.229 390.18 390.439 404.78C325.799 426.83 320.019 479.85 202.699 479.49C184.409 479.44 167.429 477.52 151.759 474.02C143.339 472.14 135.289 469.79 127.639 467.02C58.1394 441.95 20.0894 382.33 14.6594 318.62C7.49936 234.83 64.5294 192.55 101.689 167.65C138.849 142.75 181.219 50.2 296.559 49.65C314.139 49.57 331.759 51.3 348.919 55.24C388.079 64.23 428.379 85.91 452.579 118.94C454.399 121.42 456.139 123.97 457.809 126.56C490.459 177.36 494.189 248.7 475.789 304.46Z",
    fill: "#CBCBCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3496 407.05H488.29",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M403.999 40.4801C403.389 39.1101 402.639 37.7001 402.499 37.5201C400.949 35.5301 398.659 34.1201 396.429 33.0201C391.109 30.3801 384.739 33.3501 379.819 29.6201C377.749 28.0501 376.479 25.8501 375.159 23.6801C374.419 22.4701 373.669 21.2701 372.759 20.2001C369.979 16.9301 366.539 14.1601 362.679 12.2701C347.929 5.03011 331.349 13.9601 321.789 25.5501C317.129 23.2101 312.119 21.3501 306.909 21.1801C302.209 21.0301 297.749 22.4101 294.079 25.3401C291.079 27.7401 289.129 31.9101 285.389 33.3201C280.519 35.1601 275.079 32.1501 269.879 34.2701C266.629 35.6001 263.779 38.3201 260.259 38.3001C257.369 38.2801 254.819 36.3601 251.969 35.8601C247.819 35.1301 244.789 37.5801 242.289 40.4801H403.999Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.859 17.8899H213.209V128.93H276.919V62.5699H318.539V129.52H344.049V137.24H359.969V85.4699H370.779V137.24H378.179V82.6099H390.119V134.86H404.909V46.9799H431.649V104.58H447.009V18.4799H484.549V192.46",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83008 179.4H24.3501V106.96H45.3901V73.1101H85.2101V140.21H95.4501V10.0701H139.26V67.1701H166.56V17.8901H191.34",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1496 118.83H30.5996V124.77H35.1496V118.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55 118.83H38V124.77H42.55V118.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9387 118.83H45.3887V124.77H49.9387V118.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3391 118.83H52.7891V124.77H57.3391V118.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7297 118.83H60.1797V124.77H64.7297V118.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1301 118.83H67.5801V124.77H72.1301V118.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 74.8899H102.279V80.8299H106.829V74.8899Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23 74.8899H109.68V80.8299H114.23V74.8899Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 74.8899H117.068V80.8299H121.618V74.8899Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.019 74.8899H124.469V80.8299H129.019V74.8899Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 64.2H102.279V70.14H106.829V64.2Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23 64.2H109.68V70.14H114.23V64.2Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 64.2H117.068V70.14H121.618V64.2Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.019 64.2H124.469V70.14H129.019V64.2Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 53.5099H102.279V59.4499H106.829V53.5099Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23 53.5099H109.68V59.4499H114.23V53.5099Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 53.5099H117.068V59.4499H121.618V53.5099Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.019 53.5099H124.469V59.4499H129.019V53.5099Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 42.8298H102.279V48.7698H106.829V42.8298Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23 42.8298H109.68V48.7698H114.23V42.8298Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 42.8298H117.068V48.7698H121.618V42.8298Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.019 42.8298H124.469V48.7698H129.019V42.8298Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 32.1399H102.279V38.0799H106.829V32.1399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23 32.1399H109.68V38.0799H114.23V32.1399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 32.1399H117.068V38.0799H121.618V32.1399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.019 32.1399H124.469V38.0799H129.019V32.1399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.409 74.8899H131.859V80.8299H136.409V74.8899Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81 74.8899H139.26V80.8299H143.81V74.8899Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 86.7699H102.279V92.7099H106.829V86.7699Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23 86.7699H109.68V92.7099H114.23V86.7699Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 86.7699H117.068V92.7099H121.618V86.7699Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.019 86.7699H124.469V92.7099H129.019V86.7699Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.409 86.7699H131.859V92.7099H136.409V86.7699Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81 86.7699H139.26V92.7099H143.81V86.7699Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1496 131.3H30.5996V137.24H35.1496V131.3Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55 131.3H38V137.24H42.55V131.3Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9387 131.3H45.3887V137.24H49.9387V131.3Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3391 131.3H52.7891V137.24H57.3391V131.3Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7297 131.3H60.1797V137.24H64.7297V131.3Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1301 131.3H67.5801V137.24H72.1301V131.3Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1496 143.77H30.5996V149.71H35.1496V143.77Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55 143.77H38V149.71H42.55V143.77Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9387 143.77H45.3887V149.71H49.9387V143.77Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3391 143.77H52.7891V149.71H57.3391V143.77Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7297 143.77H60.1797V149.71H64.7297V143.77Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1301 143.77H67.5801V149.71H72.1301V143.77Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1496 156.24H30.5996V162.18H35.1496V156.24Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55 156.24H38V162.18H42.55V156.24Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9387 156.24H45.3887V162.18H49.9387V156.24Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3391 156.24H52.7891V162.18H57.3391V156.24Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7297 156.24H60.1797V162.18H64.7297V156.24Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1301 156.24H67.5801V162.18H72.1301V156.24Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1496 168.71H30.5996V174.65H35.1496V168.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55 168.71H38V174.65H42.55V168.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9387 168.71H45.3887V174.65H49.9387V168.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3391 168.71H52.7891V174.65H57.3391V168.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7297 168.71H60.1797V174.65H64.7297V168.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1301 168.71H67.5801V174.65H72.1301V168.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 30.95H461.23V36.8899H465.78V30.95Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 30.95H468.631V36.8899H473.181V30.95Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 30.95H476.02V36.8899H480.57V30.95Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 45.7999H461.23V51.7399H465.78V45.7999Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 45.7999H468.631V51.7399H473.181V45.7999Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 45.7999H476.02V51.7399H480.57V45.7999Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 60.6399H461.23V66.5799H465.78V60.6399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 60.6399H468.631V66.5799H473.181V60.6399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 60.6399H476.02V66.5799H480.57V60.6399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 75.48H461.23V81.42H465.78V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 75.48H468.631V81.42H473.181V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 75.48H476.02V81.42H480.57V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 90.33H461.23V96.27H465.78V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 90.33H468.631V96.27H473.181V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 90.33H476.02V96.27H480.57V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 105.17H461.23V111.11H465.78V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 105.17H468.631V111.11H473.181V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 105.17H476.02V111.11H480.57V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 120.02H461.23V125.96H465.78V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 120.02H468.631V125.96H473.181V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 120.02H476.02V125.96H480.57V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 134.86H461.23V140.8H465.78V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 134.86H468.631V140.8H473.181V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 134.86H476.02V140.8H480.57V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78 149.71H461.23V155.65H465.78V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.181 149.71H468.631V155.65H473.181V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.361 60.6399H412.811V66.5799H417.361V60.6399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.761 60.6399H420.211V66.5799H424.761V60.6399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.361 75.48H412.811V81.42H417.361V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.761 75.48H420.211V81.42H424.761V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.361 90.33H412.811V96.27H417.361V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.761 90.33H420.211V96.27H424.761V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.361 105.17H412.811V111.11H417.361V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.761 105.17H420.211V111.11H424.761V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.361 120.02H412.811V125.96H417.361V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.761 120.02H420.211V125.96H424.761V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.361 134.86H412.811V140.8H417.361V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.761 134.86H420.211V140.8H424.761V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.361 149.71H412.811V155.65H417.361V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.761 149.71H420.211V155.65H424.761V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 75.48H282.48V81.42H287.03V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.419 75.48H289.869V81.42H294.419V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 90.33H282.48V96.27H287.03V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.419 90.33H289.869V96.27H294.419V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 105.17H282.48V111.11H287.03V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.419 105.17H289.869V111.11H294.419V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 120.02H282.48V125.96H287.03V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.419 120.02H289.869V125.96H294.419V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 134.86H282.48V140.8H287.03V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.419 134.86H289.869V140.8H294.419V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 149.71H282.48V155.65H287.03V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.419 149.71H289.869V155.65H294.419V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78 75.48H299.23V81.42H303.78V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.169 75.48H306.619V81.42H311.169V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78 90.33H299.23V96.27H303.78V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.169 90.33H306.619V96.27H311.169V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78 105.17H299.23V111.11H303.78V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.169 105.17H306.619V111.11H311.169V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78 120.02H299.23V125.96H303.78V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.169 120.02H306.619V125.96H311.169V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78 134.86H299.23V140.8H303.78V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.169 134.86H306.619V140.8H311.169V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78 149.71H299.23V155.65H303.78V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.169 149.71H306.619V155.65H311.169V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 30.95H182.98V36.8899H187.53V30.95Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 30.95H190.381V36.8899H194.931V30.95Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 45.7999H182.98V51.7399H187.53V45.7999Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 45.7999H190.381V51.7399H194.931V45.7999Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 60.6399H182.98V66.5799H187.53V60.6399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 60.6399H190.381V66.5799H194.931V60.6399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 75.48H182.98V81.42H187.53V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 75.48H190.381V81.42H194.931V75.48Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 90.33H182.98V96.27H187.53V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 90.33H190.381V96.27H194.931V90.33Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 105.17H182.98V111.11H187.53V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 105.17H190.381V111.11H194.931V105.17Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 120.02H182.98V125.96H187.53V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 120.02H190.381V125.96H194.931V120.02Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 134.86H182.98V140.8H187.53V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 134.86H190.381V140.8H194.931V134.86Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 149.71H182.98V155.65H187.53V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.931 149.71H190.381V155.65H194.931V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.57 149.71H476.02V155.65H480.57V149.71Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.039 224.05H292.209V241.08H244.709V222.5H214.059V200.84H174.589V176.08H144.419V256.55L133.579 245.72V179.95H118.109V235.66H105.729V211.67H53.8793V220.18H63.1693V230.24H39.9493V245.72H26.0293",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.24 256.55H429.94V181.49H377.33V146.67H349.47V224.05H341.17",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 226.07H67.25V232.01H79.2V226.07Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6199 226.07H86.6699V232.01H98.6199V226.07Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 240.92H67.25V246.86H79.2V240.92Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6199 240.92H86.6699V246.86H98.6199V240.92Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 255.76H67.25V261.7H79.2V255.76Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6199 255.76H86.6699V261.7H98.6199V255.76Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 270.61H67.25V276.55H79.2V270.61Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6199 270.61H86.6699V276.55H98.6199V270.61Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 285.45H67.25V291.39H79.2V285.45Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6199 285.45H86.6699V291.39H98.6199V285.45Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 300.29H67.25V306.23H79.2V300.29Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6199 300.29H86.6699V306.23H98.6199V300.29Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 315.14H67.25V321.08H79.2V315.14Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6199 315.14H86.6699V321.08H98.6199V315.14Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.089 189.99H405.959V195.93H412.089V189.99Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05 189.99H415.92V195.93H422.05V189.99Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.089 204.83H405.959V210.77H412.089V204.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05 204.83H415.92V210.77H422.05V204.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.089 219.68H405.959V225.62H412.089V219.68Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05 219.68H415.92V225.62H422.05V219.68Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.089 234.52H405.959V240.46H412.089V234.52Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05 234.52H415.92V240.46H422.05V234.52Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.089 249.37H405.959V255.31H412.089V249.37Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05 249.37H415.92V255.31H422.05V249.37Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.089 264.21H405.959V270.15H412.089V264.21Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05 264.21H415.92V270.15H422.05V264.21Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.089 279.06H405.959V285H412.089V279.06Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05 279.06H415.92V285H422.05V279.06Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 189.99H359.559V195.93H365.689V189.99Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65 189.99H369.52V195.93H375.65V189.99Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 204.83H359.559V210.77H365.689V204.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65 204.83H369.52V210.77H375.65V204.83Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 219.68H359.559V225.62H365.689V219.68Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65 219.68H369.52V225.62H375.65V219.68Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 234.52H359.559V240.46H365.689V234.52Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65 234.52H369.52V240.46H375.65V234.52Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 249.37H359.559V255.31H365.689V249.37Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65 249.37H369.52V255.31H375.65V249.37Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 264.21H359.559V270.15H365.689V264.21Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65 264.21H369.52V270.15H375.65V264.21Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 279.06H359.559V285H365.689V279.06Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65 279.06H369.52V285H375.65V279.06Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.418 69.5889L156.67 51.0321L132.105 375.02L376.853 393.577L401.418 69.5889Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.869 121.57L312.499 127.61",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.189 125.77L333.299 135.03",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M382.962 208.756L155.025 191.474L154.229 201.974L382.166 219.256L382.962 208.756Z",
    fill: "#027AAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.043 191.48L382.073 208.69",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.742 202.11L381.692 219.31",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M380.413 236.21L153.463 219.02",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M383.682 192.99L156.732 175.79",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.221 172.73L158.271 155.54",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M375.769 303.622L147.832 286.34L147.036 296.839L374.973 314.122L375.769 303.622Z",
    fill: "#027AAE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M371.337 362.12L143.4 344.838L142.604 355.337L370.541 372.619L371.337 362.12Z",
    fill: "#027AAE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M387.06 150.82L159.422 133.561L142.607 355.336L370.245 372.595L387.06 150.82Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.422 344.84L370.452 362.05",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.852 286.35L374.882 303.55",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.262 327.13L372.222 344.33",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M253.882 335.78L252.602 352.68",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.492 310.89L373.452 328.09",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.553 296.97L374.503 314.17",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M209.852 316.11L208.672 331.63",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.941 317.03L220.771 332.55",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.041 317.95L232.861 333.46",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M353.592 327.01L352.412 342.52",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M318.092 340.65L316.812 357.55",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M376.632 286.11L149.672 268.91",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M267.942 278.29L266.662 295.19",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M291.282 212.98L290.002 229.87",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M274.262 165.47L272.852 184.15",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M348.012 149.01L346.482 169.24",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M377.862 269.87L150.912 252.67",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M379.132 253.04L152.182 235.84",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M314.441 265.48L313.261 281",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M302.342 264.57L301.172 280.08",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M290.252 263.65L289.082 279.17",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M170.701 254.59L169.521 270.11",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M269.981 227.95L268.691 245.02",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M257.892 227.03L256.602 244.11",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M245.802 226.12L244.502 243.19",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M167.462 220.18L166.172 237.25",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M203.741 273.43L202.451 290.33",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M374.171 48.5001H128.711V373.43H374.171V48.5001Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M210.012 113.08H289.872",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M188.711 118.91H311.171",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M366.291 188.67H137.691V199.2H366.291V188.67Z",
    fill: "#027AAE"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M137.691 188.67H365.371",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M138.191 199.29H365.791",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M365.791 216.25H138.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M365.791 172.9H138.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M365.791 152.59H138.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M366.291 283.81H137.691V294.34H366.291V283.81Z",
    fill: "#027AAE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M366.291 342.48H137.691V353.01H366.291V342.48Z",
    fill: "#027AAE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M365.991 130.59H137.691V353.01H365.991V130.59Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M137.691 342.48H365.371",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M137.691 283.81H365.371",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M138.191 324.67H365.791",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M247.152 325.09V342.04",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138.191 308.39H365.791",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.191 294.43H365.791",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M201.762 308.81V324.37",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M213.893 308.81V324.37",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M226.021 308.81V324.37",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M345.912 308.81V324.37",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M311.551 325.09V342.04",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M365.791 266.28H138.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M256.832 266.7V283.65",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M275.162 199.81V216.76",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M254.601 153.73V172.46",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M326.891 131.74V152.02",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M365.791 250H138.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M365.791 233.12H138.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M302.223 250.42V265.98",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M290.092 250.42V265.98",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M277.973 250.42V265.98",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M158.072 250.42V265.98",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M255.062 216.35V233.47",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M242.932 216.35V233.47",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M230.803 216.35V233.47",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M152.242 216.35V233.47",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M192.441 266.7V283.65",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3899 426.82L166.24 449.45L219.92 447.83C219.92 447.83 220.63 420.8 207.47 406.57C194.31 392.34 174.39 395.19 167.63 400.88C160.87 406.57 152.69 427.2 152.69 427.2L82.2599 416.88C82.2599 416.88 71.5899 391.98 58.0699 389.14C44.5499 386.3 37.5499 413.63 46.3899 426.82Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M274.651 364.75C274.651 364.75 275.161 359.99 276.861 359.82C278.561 359.65 287.921 362.54 288.091 365.6C288.261 368.66 287.071 369 285.201 369.17C283.331 369.34 279.761 369.51 279.761 369.51L274.651 364.75Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M210.9 408.23L198.88 408.8V411.44C188.27 416.83 180.85 428.32 180.85 441.29C180.85 454.26 188.27 465.06 198.88 469.44V472.08L210.9 471.51C227.49 470.73 240.94 455.92 240.94 438.45C240.94 420.97 227.49 407.45 210.9 408.23Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M198.88 472.08C215.47 472.08 228.92 457.914 228.92 440.44C228.92 422.966 215.47 408.8 198.88 408.8C182.289 408.8 168.84 422.966 168.84 440.44C168.84 457.914 182.289 472.08 198.88 472.08Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M198.88 464.34C211.411 464.34 221.57 453.64 221.57 440.44C221.57 427.24 211.411 416.54 198.88 416.54C186.348 416.54 176.19 427.24 176.19 440.44C176.19 453.64 186.348 464.34 198.88 464.34Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M198.879 446.32C201.967 446.32 204.469 443.687 204.469 440.44C204.469 437.193 201.967 434.56 198.879 434.56C195.792 434.56 193.289 437.193 193.289 440.44C193.289 443.687 195.792 446.32 198.879 446.32Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9805 395.8H60.6105V406.12C58.6605 410.74 57.4905 416.58 57.4905 422.93C57.4905 429.28 58.6605 435.12 60.6105 439.74V450.06H71.9805C79.9905 450.06 86.4805 437.91 86.4805 422.92C86.4805 407.95 79.9905 395.8 71.9805 395.8Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6096 450.08C68.6177 450.08 75.1096 437.929 75.1096 422.94C75.1096 407.951 68.6177 395.8 60.6096 395.8C52.6015 395.8 46.1096 407.951 46.1096 422.94C46.1096 437.929 52.6015 450.08 60.6096 450.08Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1904 443.44C64.4537 443.44 68.7204 434.262 68.7204 422.94C68.7204 411.618 64.4537 402.44 59.1904 402.44C53.9271 402.44 49.6604 411.618 49.6604 422.94C49.6604 434.262 53.9271 443.44 59.1904 443.44Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1901 427.99C60.488 427.99 61.5401 425.729 61.5401 422.94C61.5401 420.151 60.488 417.89 59.1901 417.89C57.8922 417.89 56.8401 420.151 56.8401 422.94C56.8401 425.729 57.8922 427.99 59.1901 427.99Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M321.371 396L309.351 396.57C292.761 396.57 279.311 410.74 279.311 428.21C279.311 445.68 292.761 459.85 309.351 459.85C310.201 459.85 311.041 459.8 311.871 459.73L321.361 459.28C337.951 458.5 351.401 443.69 351.401 426.22C351.421 408.74 337.971 395.21 321.371 396Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M283.77 371.4C283.77 371.4 263.91 356.16 255.14 349.23C246.37 342.3 232.97 336.3 229.97 335.14C226.97 333.98 196.95 331.45 176.63 330.75C156.31 330.06 125.6 330.98 110.82 333.52C96.04 336.06 82.4201 344.6 80.8001 345.53C79.1801 346.45 60.25 358.46 57.48 359.85C54.71 361.24 48.01 363.08 45.93 366.32C43.85 369.55 42.93 378.33 39.93 386.64C36.93 394.95 36.47 418.28 38.31 421.28C40.16 424.28 46.39 426.82 46.39 426.82C46.39 426.82 39 404.42 49.85 395.41C60.7 386.4 71.0901 403.49 73.8701 416.65C76.6401 429.81 76.4101 434.2 76.4101 434.2L166.24 449.44C166.24 449.44 163.93 422.42 175.25 409.49C186.57 396.56 199.27 402.33 206.66 415.96C214.05 429.59 215.43 452.68 218.21 454.99C220.98 457.3 244.07 459.38 264.16 458.45C284.25 457.53 349.37 452.22 356.07 448.98C362.77 445.75 363.69 445.05 363.23 438.59C362.77 432.12 360.69 416.88 357.92 408.34C355.15 399.8 354.92 396.56 346.37 389.64C337.83 382.71 325.82 380.17 313.35 376.25C300.86 372.32 283.77 371.4 283.77 371.4Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M283.77 371.4C283.77 371.4 263.91 356.16 255.14 349.23C249.65 344.9 242.36 340.93 236.94 338.28C224.71 337.9 177.59 336.64 154 338.84C154 338.84 168.55 364.47 171.09 373.48C171.08 373.48 256.29 374.63 283.77 371.4Z",
    fill: "#737373"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M165.26 375.81C165.26 375.81 150.8 345.7 147.57 342.97C144.34 340.25 130.39 338.38 125.62 338.21C120.86 338.04 102.31 341.27 94.66 342.97C87 344.67 66.42 358.11 66.76 360.49C67.1 362.87 71.52 366.96 72.54 367.47C73.56 367.98 165.26 375.81 165.26 375.81Z",
    fill: "#737373",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M109.301 370.95C111.771 371.17 114.271 371.39 116.781 371.61C118.051 362.74 120.491 349.63 124.861 338.21C123.721 338.24 122.121 338.38 120.231 338.6C116.881 344.45 111.471 355.78 109.301 370.95Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7892 343.89C90.0692 344.57 88.0792 345.51 85.9892 346.62C81.2192 353.61 75.4892 363.45 73.1292 367.57C74.2692 367.72 76.9792 368 80.8092 368.36C81.0692 366.79 81.5392 364.46 82.3992 361C83.8492 355.21 88.6492 348.11 91.7892 343.89Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M143.141 374.4C143.141 374.4 148.681 380.4 150.761 380.87C152.841 381.33 158.841 379.72 157.921 378.1C157.001 376.48 151.921 374.17 151.921 374.17L143.141 374.4Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M154.46 376.25C154.46 376.25 154.69 371.63 152.84 368.4C150.99 365.17 147.3 362.4 145.45 362.4C143.6 362.4 131.83 362.86 130.67 365.86C129.52 368.86 130.44 372.56 134.13 374.4C137.83 376.25 153.3 376.02 154.46 376.25Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M122.549 383.63L109.789 382.27L109.959 384.82L121.019 386.35L122.549 383.63Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0191 379.89L78.9992 382.44L70.1492 381.25L69.1292 378.87L80.0191 379.89Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M107.59 415.93C107.76 420.93 107.92 424.47 107.92 424.47",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M110.13 373.08C110.13 373.08 108.09 377.5 107.41 388.05C107.06 393.4 107.2 402.7 107.42 410.56",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M164.77 393.8C163.94 401.33 163.13 410.69 163.22 418C163.39 432.63 163.22 442.33 163.22 442.33",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M166.451 380.57C166.451 380.57 165.931 384.04 165.311 389.14",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M142.51 439.23C152.28 440.93 159.47 442.16 159.47 442.16",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1699 418.17C79.1699 418.17 81.3799 426.85 90.3999 429.4C95.7699 430.92 119.24 435.15 137.35 438.33",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8305 368.66C70.8305 368.66 65.9005 374.27 65.5605 376.49C65.2205 378.7 66.0705 388.57 67.7705 392.82C69.4705 397.07 74.7505 410.51 74.7505 410.51",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8198 370.7C45.8198 370.7 41.7398 370.87 41.0598 372.91C40.3798 374.95 39.8698 382.78 41.0598 382.61C42.2498 382.44 48.5498 373.93 48.3798 372.4C48.1998 370.87 45.8198 370.7 45.8198 370.7Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M343.219 407.79C343.219 407.79 311.059 410.51 301.709 410.17C292.349 409.83 287.079 409.32 285.889 408.81C284.699 408.3 283.849 407.79 283.849 407.79C283.849 407.79 279.769 403.54 274.829 403.03C269.899 402.52 224.639 395.71 219.539 396.56C214.439 397.41 210.179 400.13 213.249 402.68C216.309 405.23 220.229 409.66 222.949 410.51C225.669 411.36 282.499 417.66 282.499 417.66C282.499 417.66 291.349 422.25 299.509 422.25C307.679 422.25 340.679 419.53 343.229 418.68C345.779 417.83 348.329 412.21 351.229 410C354.129 407.79 356.669 404.73 356.669 404.73C356.669 404.73 354.119 397.07 353.609 396.56C353.099 396.05 352.419 395.37 352.419 395.37C352.419 395.37 345.439 399.96 344.929 402.01C344.409 404.05 343.219 407.79 343.219 407.79Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M279.42 409.32L273.64 414.25C273.64 414.25 224.13 409.15 222.26 408.47C220.39 407.79 215.45 402.86 215.11 401.32C214.77 399.79 217.83 397.75 219.02 397.75C220.21 397.75 272.61 404.73 273.97 404.9C275.33 405.07 279.42 409.32 279.42 409.32Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M352.24 397.24C352.24 397.24 347.99 399.45 346.63 401.32C345.27 403.19 343.4 409.15 344.76 409.49C346.12 409.83 348.84 409.83 349.35 409.66C349.86 409.49 355.47 404.39 355.47 404.39C355.47 404.39 353.43 398.43 352.24 397.24Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M358.699 445.56C359.769 444.82 361.479 443.82 363.159 442.88C363.349 441.79 363.339 440.43 363.209 438.6C362.969 435.27 362.299 429.61 361.329 423.74L359.379 423.79C359.379 423.79 358.529 423.96 358.359 425.15C358.189 426.34 357.849 442.16 357.849 442.16C357.849 442.16 356.489 443.86 355.639 443.52C354.789 443.18 354.959 427.19 352.919 426.34C350.879 425.49 293.029 428.72 289.629 429.23C286.229 429.74 273.639 449.65 272.279 450.16C270.919 450.67 256.119 448.12 254.079 447.95C252.039 447.78 265.309 429.06 265.309 429.06C265.309 429.06 246.079 429.23 239.619 430.25C233.149 431.27 227.879 445.39 227.879 445.39C227.879 445.39 228.219 446.24 235.199 448.28C242.179 450.32 273.139 453.21 275.689 453.38C277.629 453.51 273.489 456.57 271.379 458.05C277.759 457.66 285.939 457.07 294.699 456.36L343.819 451.41C348.069 450.82 351.499 450.25 353.729 449.71C354.809 448.68 356.839 446.84 358.699 445.56Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M334.371 438.75L310.721 439.78V425.83L334.371 424.8V438.75Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M335.17 392.73C343.9 392.15 345.44 390.77 345.44 390.77",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M204.879 388.75C217.899 391.13 233.229 393.74 235.699 393.84C239.489 393.99 306.519 393.47 328.069 392.99",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M184.99 375.13C184.99 375.13 182.61 375.64 182.61 377.85C182.61 380.06 183.12 383.97 186.01 385C186.99 385.35 192.57 386.46 199.66 387.79",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M331.99 407.04C331.99 410.55 326.59 413.4 319.92 413.4C313.26 413.4 307.85 410.55 307.85 407.04C307.85 403.53 313.25 400.68 319.92 400.68C326.58 400.68 331.99 403.53 331.99 407.04Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M256.52 350.32C256.04 349.94 255.57 349.57 255.14 349.23C251.69 346.51 247.53 343.93 243.57 341.73L225.83 373.59C232.41 373.53 239.08 373.44 245.53 373.31L256.52 350.32Z",
    fill: "#CBCBCB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M204.741 337.63L176.151 373.53C183.431 373.6 197.791 373.71 214.001 373.66L236.041 338.25C230.181 338.07 218.261 337.76 204.741 337.63Z",
    fill: "#CBCBCB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M283.77 371.4C283.77 371.4 263.91 356.16 255.14 349.23C249.65 344.9 242.36 340.93 236.94 338.28C224.71 337.9 177.59 336.64 154 338.84C154 338.84 168.55 364.47 171.09 373.48C171.08 373.48 256.29 374.63 283.77 371.4Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M389.44 466.84C389.44 466.84 389.02 469.31 390.07 469.79C391.12 470.27 395.13 470.55 396.75 470.08C398.37 469.6 400.28 469.51 400.28 469.51C400.28 469.51 405.25 469.99 406.2 468.27C407.15 466.55 405.25 465.21 404.58 465.02C403.91 464.83 399.61 464.26 399.61 464.26L398.18 463.69L389.44 466.84Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M393.251 405.8C393.251 405.8 388.701 435.88 388.411 446.59C388.121 457.3 389.441 466.84 389.441 466.84C389.441 466.84 392.671 466.99 393.991 466.69C395.311 466.4 398.981 463.76 398.981 463.76L400.011 419.89L393.251 405.8Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M412.97 470.92C412.97 470.92 417.09 475.04 419.38 475.9C421.67 476.76 423.58 477.24 423.68 478.19C423.78 479.14 423.39 480.77 420.72 481.53C418.05 482.29 410.79 481.63 408.59 481.05C406.39 480.48 401.91 478.76 400.95 478.38C400 478 399.52 477.62 399.42 476.66C399.32 475.71 399.53 473.56 399.53 473.56C399.53 473.56 406.67 470.17 408.49 469.88C410.31 469.6 412.97 470.92 412.97 470.92Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M387.48 371.04C387.48 371.04 385.99 381.72 386.33 386.65C386.67 391.58 396.89 420.63 396.89 420.63C396.89 420.63 397.12 449.1 397.69 455.76C398.26 462.42 399.18 469.65 399.18 469.65C399.18 469.65 399.41 471.14 399.52 471.49C399.63 471.84 399.52 473.56 399.52 473.56C399.52 473.56 405.15 473.9 406.18 472.99C407.21 472.07 412.95 470.92 412.95 470.92C412.95 470.92 413.41 469.66 412.61 467.02C411.81 464.38 410.08 460.02 410.08 460.02L414.44 409.62C414.44 409.62 414.78 392.86 413.98 387.12C413.18 381.38 412.33 372.62 412.33 372.62L387.48 371.04Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M392.84 322.78C392.84 322.78 386.55 328.07 384.16 336.37C381.77 344.68 384.66 370.48 385.29 371.36C385.92 372.24 386.8 372.74 387.93 372.74C389.06 372.74 411.59 373.12 412.35 372.61C413.11 372.11 413.48 370.6 413.48 368.96C413.48 367.32 408.8 340.05 406.94 336.74C405.07 333.43 403.92 331.96 403.92 331.96L392.84 322.78Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M394.43 320.25C394.43 320.25 394.7 319.16 395.61 317.25C396.52 315.34 395.7 310.79 396.06 307.61C396.42 304.43 398.97 302.43 398.97 302.43C398.97 302.43 401.52 300.25 406.7 301.07C411.88 301.89 415.34 306.98 415.61 309.53C415.88 312.08 416.06 313.17 415.52 313.99C414.97 314.81 415.79 317.45 415.43 318.08C415.07 318.72 412.97 319.08 412.97 319.08C412.97 319.08 411.51 323.08 410.79 323.99C410.07 324.9 405.88 323.72 405.88 323.72L403.52 326.99L394.43 320.25Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M414.079 305.98C412.549 303.78 409.969 301.58 406.709 301.06C401.529 300.24 398.979 302.42 398.979 302.42C398.979 302.42 396.429 304.42 396.069 307.6C395.769 310.2 396.259 313.7 395.959 315.94L396.339 316.51L399.609 316.33L399.059 317.69C399.059 317.69 401.609 316.33 402.059 315.51C402.509 314.69 402.789 312.78 403.879 312.69C404.969 312.6 405.609 312.78 405.609 312.78L407.699 310.96C407.699 310.96 411.159 309.6 410.159 307.41C409.159 305.23 407.069 303.86 407.069 303.86L408.799 303.95L407.619 302.95C407.619 302.95 409.349 303.04 410.989 304.04C412.059 304.71 413.549 306.06 414.079 305.98Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M405.799 317.07C405.349 317.8 404.709 318.16 403.889 317.62C403.069 317.07 402.339 314.62 403.249 313.07C404.159 311.52 405.609 312.8 405.609 312.8L406.339 313.89",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M415.62 313.15C415.62 313.15 414.26 312.15 412.98 312.97",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M413.979 314.9C413.899 315.37 413.669 315.72 413.479 315.69C413.279 315.66 413.189 315.25 413.269 314.78C413.349 314.31 413.579 313.96 413.769 313.99C413.969 314.02 414.059 314.43 413.979 314.9Z",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M412.17 320.43C412.17 320.43 410.62 320.25 410.35 318.7",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M393.519 319.43L405.439 327.71L405.069 333.44L391.699 322.89L393.519 319.43Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M410.31 343.86L400.93 358.38L415.85 358.68L427.34 344.47L410.31 343.86Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M414.941 344.37L413.731 345.98L421.701 346.08L423.131 344.61L414.941 344.37Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M415.119 356.76C415.119 356.76 416.839 354.92 417.679 353.54C418.519 352.16 422.819 350.09 423.439 349.39C424.049 348.7 424.899 348.08 425.209 348.55C425.519 349.01 425.519 349.01 425.519 349.01C425.519 349.01 426.289 349.78 426.059 350.93C425.829 352.08 426.059 354.08 425.599 355.08C425.139 356.08 422.679 358.76 421.609 359.3C420.539 359.84 416.769 360.76 416.769 360.76L415.769 360.99L415.119 356.76Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M425.509 349.01C425.509 349.01 425.889 350.08 425.509 350.7C425.129 351.31 423.439 352.62 422.979 352.85",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M388.059 334.73C388.059 334.73 383.909 341.27 384.159 345.43C384.409 349.59 388.309 364.94 389.189 366.32C390.069 367.7 392.209 369.09 393.849 369.21C395.489 369.34 406.309 367.7 408.949 366.82C411.589 365.94 413.229 363.93 413.229 363.93C413.229 363.93 415.239 363.8 415.749 362.8C416.249 361.79 415.119 356.76 415.119 356.76L410.339 357.26L401.029 357.39C401.029 357.39 402.039 353.99 401.789 351.6C401.539 349.21 403.169 341.91 400.909 338.13C398.639 334.35 396.759 332.47 396.759 332.47",
    fill: "#CBCBCB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M388.059 334.73C388.059 334.73 383.909 341.27 384.159 345.43C384.409 349.59 388.309 364.94 389.189 366.32C390.069 367.7 392.209 369.09 393.849 369.21C395.489 369.34 406.309 367.7 408.949 366.82C411.589 365.94 413.229 363.93 413.229 363.93C413.229 363.93 415.239 363.8 415.749 362.8C416.249 361.79 415.119 356.76 415.119 356.76L410.339 357.26L401.029 357.39C401.029 357.39 402.039 353.99 401.789 351.6C401.539 349.21 403.169 341.91 400.909 338.13C398.639 334.35 396.759 332.47 396.759 332.47",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M399.89 357.89C399.89 357.89 396.74 362.17 394.48 363.43",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M401.909 358.65C401.909 358.65 401.779 361.17 400.529 363.31",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M442.91 418.23C442.91 418.23 442.21 426.22 443.41 436.92C444.61 447.61 444.61 458.1 443.51 460.4C442.41 462.7 440.31 464.9 440.11 465.8C439.91 466.7 442.11 467.2 443.81 466.6C445.51 466 447.51 465.2 448.01 463.7C448.51 462.2 449.81 458.8 449.81 458.8L449.51 463.1C449.51 463.1 450.91 463.6 451.01 463C451.11 462.4 450.81 457.7 450.91 457.1C451.01 456.5 452.21 453.8 451.91 452C451.61 450.2 449.41 448.9 449.41 448.9C449.41 448.9 449.51 438.71 450.41 435.31C451.31 431.91 452.41 425.42 451.71 421.12L442.91 418.23Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M451.91 452.01C451.74 451.02 451.01 450.19 450.37 449.64C450.34 449.79 450.32 449.94 450.31 450.12C450.21 451.72 449.61 457.11 448.71 459.11C447.81 461.11 446.61 463.11 445.21 463.51C444.05 463.84 442.51 463.15 442 462.9C441.1 464.18 440.24 465.24 440.12 465.8C439.92 466.7 442.12 467.2 443.82 466.6C445.52 466 447.52 465.2 448.02 463.7C448.52 462.2 449.82 458.8 449.82 458.8L449.52 463.1C449.52 463.1 450.92 463.6 451.02 463C451.12 462.4 450.82 457.7 450.92 457.1C451.01 456.5 452.21 453.81 451.91 452.01Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M457.699 421.63C457.699 421.63 458.599 429.62 460.399 435.52C462.199 441.42 462.799 454.01 463.699 458.6C464.599 463.2 463.999 467.59 464.799 470.09C465.599 472.59 467.099 473.29 468.599 472.89C470.099 472.49 470.999 470.69 470.899 468.39C470.799 466.09 467.599 458.3 467.499 456.1C467.399 453.9 468.899 435.52 468.599 430.82C468.299 426.12 465.299 419.53 465.299 419.53L457.699 421.63Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M470.889 468.39C470.869 467.94 470.729 467.28 470.519 466.5C470.169 467.94 469.499 469.39 468.189 469.39C465.589 469.39 464.589 468.19 464.589 468.19L464.469 468.38C464.539 469.01 464.629 469.59 464.789 470.09C465.589 472.59 467.089 473.29 468.589 472.89C470.089 472.49 470.989 470.69 470.889 468.39Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M435.301 365.45C435.301 365.45 433.901 371.59 434.071 374.93C434.251 378.26 433.891 387.15 433.891 387.15C433.891 387.15 433.191 391.01 433.361 391.71C433.541 392.41 434.591 394.87 435.641 395.22C436.691 395.57 438.271 394.17 438.451 393.64C438.631 393.11 440.911 368.26 440.911 368.26L435.301 365.45Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M437.58 353.87C437.58 353.87 433.19 366.86 433.89 367.03C434.59 367.21 435.12 368.26 436.17 368.79C437.22 369.32 438.98 369.67 438.98 369.67L443.89 355.98C443.9 355.98 439.87 351.59 437.58 353.87Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M439.419 364.28C439.419 364.28 436.199 375.38 436.199 385.05C436.199 394.72 441.519 419.68 441.519 419.68C441.519 419.68 446.669 422.74 455.369 423.06C464.069 423.38 466.159 420.97 466.159 420.97C466.159 420.97 464.999 409.23 466.159 400.99C467.869 388.84 466.649 378.64 462.779 370.88C460.519 366.36 460.039 365.24 460.039 365.24L439.419 364.28Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M447.549 334.7C447.549 334.7 440.339 336.86 439.699 337.81C439.059 338.77 436.299 349.3 436.939 351.11C437.579 352.92 438.959 361.85 438.959 361.85C438.959 361.85 438.109 364.93 438.849 365.79C439.589 366.64 447.039 369.51 453.419 368.77C459.799 368.03 461.289 366.64 461.609 365.15C461.929 363.66 461.929 362.49 461.929 362.49C461.929 362.49 465.859 342.07 465.859 340.47C465.859 338.87 459.259 336.43 458.839 335.79C458.419 335.15 447.549 334.7 447.549 334.7Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M449.13 314.77C449.13 314.77 448.94 314.82 448.66 314.93C447.81 315.25 446.1 316.04 445.97 317.35C445.8 319.09 447.3 320.76 447.05 322C446.8 323.25 445.64 330.89 444.89 331.3C444.14 331.72 443.39 331.47 443.39 331.47C443.39 331.47 442.81 333.88 447.54 334.71C452.27 335.54 457.59 337.87 461.33 335.71C465.07 333.55 465.65 329.23 465.23 323.17C464.81 317.11 460.33 315.11 456.67 314.2C453.04 313.27 449.13 314.77 449.13 314.77Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M448.74 333.35C448.74 333.35 445.87 335.05 445.87 335.58C445.87 336.11 445.23 339.84 445.23 339.84L449.38 337.39L452.89 337.71L454.8 342.5C454.8 342.5 459.91 337.18 459.8 335.8C459.69 334.42 459.37 332.82 458.74 332.18C458.1 331.54 454.59 331.22 454.59 331.22L448.74 333.35Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M448.299 332.21C448.299 332.21 448.379 333.87 448.299 334.29C448.219 334.71 447.879 342.68 448.799 342.43C449.709 342.18 456.689 335.95 457.109 334.95C457.529 333.95 456.029 328.97 456.029 328.97C456.029 328.97 449.959 332.13 448.299 332.21Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M448.631 317.76C448.631 317.76 446.141 322.83 445.471 325.57C444.811 328.31 444.311 331.72 445.801 332.46C447.301 333.21 452.361 332.88 454.111 332.21C455.851 331.55 456.441 329.88 456.441 329.88C456.441 329.88 457.821 329.88 458.851 329.3C460.181 328.55 460.011 327.31 459.511 327.06C459.011 326.81 457.681 327.06 457.181 327.06C456.681 327.06 457.011 327.39 456.681 327.06C456.351 326.73 456.101 325.98 456.511 325.23C456.931 324.48 456.931 322.41 456.261 321.74C455.601 321.08 453.351 320.49 451.771 318.92C450.211 317.34 449.301 316.68 448.631 317.76Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M447.801 326.73C447.051 326.81 446.221 325.82 445.471 325.57C444.721 325.32 448.291 322.33 448.381 322.08C448.461 321.83 448.551 320.75 448.551 320.75C448.551 320.75 448.301 319.92 447.801 319.75",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M446.141 327.89C446.141 327.89 447.971 329.97 450.711 328.8",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M451.291 324.67C451.101 325.15 450.691 325.44 450.391 325.32C450.081 325.2 449.991 324.71 450.181 324.23C450.371 323.75 450.781 323.46 451.081 323.58C451.391 323.7 451.481 324.19 451.291 324.67Z",
    fill: "#263238"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M450.381 321.91C450.381 321.91 452.371 321.83 453.121 324.15",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M452.889 358.24C452.889 358.24 432.149 355.47 431.509 355.26C430.869 355.05 426.079 356 425.549 356.22C425.019 356.43 422.779 360.16 422.779 360.16C422.779 360.16 424.799 361.86 425.329 362.07C425.859 362.28 426.179 362.81 426.389 362.39C426.599 361.96 429.369 361.22 431.499 360.58C433.629 359.94 434.269 359.73 434.269 359.73C434.269 359.73 449.799 364.52 450.969 364.62C452.139 364.73 453.309 364.41 453.309 364.41L452.889 358.24Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M460.441 342.92L455.441 356.11C455.441 356.11 454.591 356.32 454.161 356.64C453.731 356.96 451.391 357.38 451.391 357.38L453.621 365.25C453.621 365.25 456.921 364.51 457.661 364.08C458.401 363.65 459.791 361.63 459.791 361.63C459.791 361.63 461.921 361.1 462.661 360.03C463.401 358.97 467.341 345.35 467.661 342.69C467.981 340.03 461.491 337.37 461.491 337.37",
    fill: "#027AAE"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M460.441 342.92L455.441 356.11C455.441 356.11 454.591 356.32 454.161 356.64C453.731 356.96 451.391 357.38 451.391 357.38L453.621 365.25C453.621 365.25 456.921 364.51 457.661 364.08C458.401 363.65 459.791 361.63 459.791 361.63C459.791 361.63 461.921 361.1 462.661 360.03C463.401 358.97 467.341 345.35 467.661 342.69C467.981 340.03 461.491 337.37 461.491 337.37",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M455.871 356.85C455.871 356.85 458.321 358.02 459.061 361.32",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M456.301 355.9C456.301 355.9 458.851 356.43 460.021 357.07",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M425.981 353.02C425.981 353.02 428.001 353.66 429.491 353.55C430.981 353.44 432.261 354.83 431.511 355.25C430.771 355.68 428.211 355.36 428.211 355.36L425.551 356.21L425.981 353.02Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M430.659 358.87C430.659 358.87 429.279 358.66 429.599 360.25C429.919 361.85 432.259 362.16 432.679 361.53C433.109 360.89 432.309 359.49 430.659 358.87Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M428.849 360.31C428.849 360.31 427.149 358.68 426.649 358.74C426.149 358.8 425.649 359.49 426.079 360.18C426.519 360.87 427.899 362.32 428.339 362.32C428.779 362.32 429.159 362.19 429.409 361.57C429.669 360.94 428.849 360.31 428.849 360.31Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M426.089 360.18C426.089 360.18 424.709 360.24 424.769 360.81C424.829 361.38 425.399 362.88 425.959 363.26C426.529 363.64 427.339 363.39 427.529 362.82C427.719 362.26 426.089 360.18 426.089 360.18Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M424.291 360.5C424.291 360.5 423.331 360.54 423.381 360.93C423.421 361.32 423.811 362.36 424.211 362.62C424.601 362.88 425.171 362.71 425.301 362.32C425.421 361.93 424.291 360.5 424.291 360.5Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1805 182.93C110.79 159.11 141.76 146.79 156.81 135.56L160.66 132.38H149.21C136.15 144.56 102.71 156.85 63.7305 182.93C63.7305 182.93 66.1705 271.06 149.21 319.23H160.66C77.6205 271.05 75.1805 182.93 75.1805 182.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M160.66 132.38C147.6 144.56 114.16 156.85 75.1797 182.93C75.1797 182.93 77.6197 271.06 160.66 319.23C243.71 271.06 246.14 182.93 246.14 182.93C207.16 156.85 173.72 144.56 160.66 132.38Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M160.661 139.88C144.891 150.83 117.571 161.25 81.4512 185.42C81.4512 185.42 83.7112 267.08 160.661 311.72C237.611 267.08 239.871 185.42 239.871 185.42C203.751 161.25 176.551 150.83 160.661 139.88Z",
    fill: "#CBCBCB",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M160.66 300.04C133.57 282.98 113.77 259.07 101.79 228.9C95.1902 212.28 92.7802 197.92 91.9102 190.51C110.45 178.47 126.58 170.07 139.74 163.21C147.59 159.12 154.65 155.44 160.67 151.78C166.66 155.4 173.64 159.04 181.41 163.1C194.6 169.98 210.77 178.41 229.4 190.51C228.54 197.92 226.13 212.28 219.52 228.9C207.55 259.07 187.75 282.98 160.66 300.04Z",
    fill: "#027AAE",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M117.98 259.33C129.17 275.56 143.43 289.19 160.66 300.04C187.75 282.98 207.55 259.07 219.53 228.9C226.14 212.27 228.54 197.92 229.41 190.51C229.41 190.5 195.38 235.57 117.98 259.33Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M160.09 250.52C157.99 250.52 156 249.57 154.69 247.94L130.61 218.13C128.2 215.15 128.66 210.77 131.65 208.36C134.63 205.95 139.01 206.41 141.42 209.4L160.07 232.5L205.69 175.6C208.09 172.61 212.46 172.13 215.46 174.53C218.45 176.93 218.93 181.3 216.53 184.3L165.51 247.94C164.19 249.58 162.21 250.54 160.1 250.54C160.09 250.52 160.09 250.52 160.09 250.52Z",
    fill: "#CBCBCB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M153.1 245.98L154.68 247.94C156 249.57 157.99 250.52 160.08 250.52H160.09C162.19 250.52 164.18 249.56 165.5 247.92L177.13 233.42C169.92 237.69 161.92 241.93 153.1 245.98Z",
    fill: "#BFBFBF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M160.09 250.52C157.99 250.52 156 249.57 154.69 247.94L130.61 218.13C128.2 215.15 128.66 210.77 131.65 208.36C134.63 205.95 139.01 206.41 141.42 209.4L160.07 232.5L205.69 175.6C208.09 172.61 212.46 172.13 215.46 174.53C218.45 176.93 218.93 181.3 216.53 184.3L165.51 247.94C164.19 249.58 162.21 250.54 160.1 250.54C160.09 250.52 160.09 250.52 160.09 250.52Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M200.84 98.57H197.43V84.37H200.84V98.57Z",
    fill: "#E59411"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M215.09 98.57H211.69L206.66 89.73V98.57H203.24V84.37H206.66L211.68 93.21V84.37H215.09V98.57Z",
    fill: "#E59411"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M224.58 94.8001C224.58 94.3001 224.4 93.9101 224.05 93.6301C223.7 93.3501 223.07 93.0601 222.18 92.7601C221.29 92.4601 220.56 92.1701 219.99 91.8901C218.15 90.9901 217.23 89.7401 217.23 88.1601C217.23 87.3701 217.46 86.6801 217.92 86.0801C218.38 85.4801 219.03 85.0101 219.87 84.6801C220.71 84.3401 221.65 84.1801 222.7 84.1801C223.72 84.1801 224.64 84.3601 225.45 84.7301C226.26 85.0901 226.89 85.6101 227.34 86.2901C227.79 86.9601 228.01 87.7301 228.01 88.6001H224.6C224.6 88.0201 224.42 87.5701 224.07 87.2501C223.72 86.9301 223.24 86.7701 222.63 86.7701C222.02 86.7701 221.54 86.9001 221.18 87.1701C220.83 87.4401 220.65 87.7801 220.65 88.2001C220.65 88.5601 220.85 88.8901 221.24 89.1901C221.63 89.4901 222.32 89.7901 223.3 90.1101C224.28 90.4301 225.09 90.7701 225.72 91.1301C227.25 92.0101 228.02 93.2301 228.02 94.7901C228.02 96.0301 227.55 97.0101 226.62 97.7201C225.68 98.4301 224.4 98.7801 222.77 98.7801C221.62 98.7801 220.58 98.5701 219.64 98.1601C218.71 97.7501 218 97.1801 217.53 96.4601C217.06 95.7401 216.82 94.9101 216.82 93.9801H220.25C220.25 94.7401 220.45 95.3001 220.84 95.6601C221.23 96.0201 221.87 96.2001 222.76 96.2001C223.33 96.2001 223.77 96.0801 224.1 95.8301C224.41 95.5801 224.58 95.2401 224.58 94.8001Z",
    fill: "#E59411"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M240.899 84.3701V93.6701C240.899 94.7201 240.679 95.6401 240.229 96.4101C239.779 97.1801 239.139 97.7701 238.299 98.1701C237.459 98.5701 236.469 98.7701 235.319 98.7701C233.589 98.7701 232.229 98.3201 231.229 97.4201C230.229 96.5201 229.729 95.2901 229.709 93.7301V84.3601H233.149V93.7901C233.189 95.3401 233.909 96.1201 235.319 96.1201C236.029 96.1201 236.569 95.9201 236.929 95.5301C237.289 95.1401 237.479 94.5101 237.479 93.6301V84.3501H240.899V84.3701Z",
    fill: "#E59411"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M248.309 93.55H246.459V98.57H243.039V84.37H248.629C250.309 84.37 251.629 84.74 252.579 85.49C253.529 86.24 253.999 87.29 253.999 88.66C253.999 89.65 253.799 90.47 253.399 91.12C252.999 91.77 252.369 92.3 251.519 92.7L254.489 98.44V98.59H250.819L248.309 93.55ZM246.459 90.91H248.629C249.279 90.91 249.769 90.74 250.099 90.4C250.429 90.06 250.589 89.58 250.589 88.97C250.589 88.36 250.419 87.88 250.089 87.53C249.759 87.18 249.269 87.01 248.629 87.01H246.459V90.91Z",
    fill: "#E59411"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M264.139 95.92H259.449L258.629 98.57H254.969L260.179 84.37H263.399L268.649 98.57H264.969L264.139 95.92ZM260.259 93.28H263.309L261.779 88.35L260.259 93.28Z",
    fill: "#E59411"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M281.539 98.57H278.139L273.109 89.73V98.57H269.689V84.37H273.109L278.129 93.21V84.37H281.539V98.57Z",
    fill: "#E59411"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M295.201 93.76C295.151 94.75 294.891 95.62 294.401 96.38C293.911 97.14 293.231 97.72 292.351 98.14C291.471 98.56 290.461 98.76 289.331 98.76C287.461 98.76 285.991 98.15 284.921 96.94C283.851 95.72 283.311 94.01 283.311 91.79V91.09C283.311 89.7 283.551 88.48 284.041 87.44C284.521 86.4 285.221 85.59 286.131 85.02C287.041 84.45 288.091 84.17 289.291 84.17C291.011 84.17 292.401 84.62 293.451 85.53C294.501 86.44 295.091 87.69 295.241 89.28H291.831C291.801 88.42 291.591 87.79 291.181 87.42C290.771 87.04 290.151 86.85 289.311 86.85C288.461 86.85 287.831 87.17 287.441 87.81C287.041 88.45 286.831 89.47 286.821 90.86V91.86C286.821 93.38 287.011 94.46 287.391 95.11C287.771 95.76 288.431 96.09 289.361 96.09C290.151 96.09 290.751 95.9 291.161 95.53C291.581 95.16 291.801 94.57 291.821 93.76H295.201Z",
    fill: "#E59411"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M305.62 92.5401H300.24V95.9301H306.6V98.5601H296.82V84.3601H306.62V87.0001H300.24V89.9901H305.62V92.5401Z",
    fill: "#E59411"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b63706c19befce3d1a5a23cafefc9ce3.svg";
export { ForwardRef as ReactComponent };